import styled from "styled-components";

const NumberedDisclaimerIcon = styled.span`
    margin: 0;
    margin-inline-end: calc(var(--spacing-1) / 2);
    font-family: var(--font-book);
    font-size: 0.7rem;
    line-height: 1.2rem;

    &:first-child {
        margin-inline-start: 0;
    }

    &:last-child {
        margin-inline-end: 0;
    }
`;

export default NumberedDisclaimerIcon;
